"use strict";

module.exports = {
  'name': 'unaryPlus',
  'category': 'Operators',
  'syntax': ['+x', 'unaryPlus(x)'],
  'description': 'Converts booleans and strings to numbers.',
  'examples': ['+true', '+"2"'],
  'seealso': ['add', 'subtract', 'unaryMinus']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/arithmetic/unaryPlus.js
// module id = 858
// module chunks = 0